import { KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME, KingspanConfigurationFormServiceProvider } from './kingspan-configuration-form.service'

export const KINGSPAN_CONFIGURATION_FORM_SERVICES_MODULE_NAME = 'simax.services.kingspanConfigurationForm'

const KingspanConfigurationFormServicesModule = angular.module(KINGSPAN_CONFIGURATION_FORM_SERVICES_MODULE_NAME, [])

KingspanConfigurationFormServicesModule.provider(KINGSPAN_CONFIGURATION_FORM_SERVICE_NAME, KingspanConfigurationFormServiceProvider)
